type Direction = 'asc' | 'desc';

/**
 * This sort helper uses a property selector to turn any complex propety into a string value
 * so that it can be sorted.  Property selectors should be added in order so that the primary
 * sort is first, followed by the secondary and so on.
 */
export class SortHelper<T> {
	private sortProperties = Array<{ predicate: (t: T) => string; direction: Direction }>();

	public AddSortProperty(propertySelector: (t: T) => string, direction?: Direction) {
		this.sortProperties.push({ predicate: propertySelector, direction: direction || 'asc' });
		return this;
	}

	public Sort(items: T[]) {
		const getSortFunc = (direction: Direction, propertySelector: (q: T) => string, secondarySort?: (a: T, b: T) => number) => {
			const sortFunc = (a: T, b: T) => {
				const aValue = propertySelector(a).toUpperCase();
				const bValue = propertySelector(b).toUpperCase();
				if (aValue > bValue) {
					return direction === 'asc' ? 1 : -1;
				}
				if (aValue < bValue) {
					return direction === 'asc' ? -1 : 1;
				}
				if (secondarySort) {
					return secondarySort(a, b);
				}
				return 0;
			};
			return sortFunc;
		};
		let prevSortFunc;
		for (let i = this.sortProperties.length - 1; i >= 0; i--) {
			const { direction, predicate } = this.sortProperties[i];
			prevSortFunc = getSortFunc(direction, predicate, prevSortFunc);
		}
		return [...items].sort(prevSortFunc);
	}
}
